import React, { useState, useEffect, useContext } from 'react';
import { EnvironmentContext } from '../../EnvironmentContext';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import APIServices from '../../services/APIServices';
import { Backdrop, CircularProgress } from '@mui/material';
import { setHomePageReviews, setAccessToken } from '../../Redux/Actions';
import ButtonCompo from '../../Components/ButtonComponent/ButtonCompo';
import AlertComponent from '../../Components/Alert/Alert';
import apiconfig from '../../config/config';

const RenderReviews = () => {
    const navigate = useNavigate
    const { environment } = useContext(EnvironmentContext)
    const homepageReviews = useSelector((state) => state.homepageReviews);
    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [homeReview, setHomeReview] = useState(homepageReviews);
    const [randomNumber, setRandomNumber] = useState(null);
    const [reviewUpdateAlert, setReviewUpdateAlert] = useState(false);
    const [errAlert, setErrAlert] = useState(false);
    const accessToken = useSelector((state) => state.accessToken);
    const adminDetails = useSelector((state) => state?.loginUserDetails);

    const adminMail = adminDetails?.mail
    const testingEnvironmentIds = {
        "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
        "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
    };

    const productionEnvironmentIds = {
        "support@meetbytravel.com": "669f4b370e0130ee414ef469",
        "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
    };

    let adminUserId;
    if (environment === "Production") {
        adminUserId = productionEnvironmentIds[adminMail];
    } else if (environment === "Testing") {
        adminUserId = testingEnvironmentIds[adminMail];
    }


    useEffect(() => {
        const tokenLocal = JSON.parse(localStorage.getItem("token"));
        if (!accessToken && tokenLocal) {
            dispatch(setAccessToken(tokenLocal));
            APIServices.setAuthToken(tokenLocal);
        } else if (!accessToken && !tokenLocal) {
            navigate("/login");
        }
        if (accessToken || tokenLocal) {
            setIsLoading(true);
            const tokenToUse = accessToken || tokenLocal;
            APIServices.setAuthToken(tokenToUse);
            const url = environment === "Production"
                ? apiconfig.production.apiBaseUrl
                : apiconfig.develpoment.apiBaseUrl;

            APIServices.setApiBaseUrl(url);
            APIServices.getHomepageReviews()
                .then((res) => {
                    // console.log("reviews :", res?.data?.reviews)
                    dispatch(setHomePageReviews(res?.data?.reviews));
                    setHomeReview(res?.data?.reviews);
                    setIsLoading(false);
                })
                .catch((err) => {
                    console.error("Error in getting reviews:", err);
                    setIsLoading(false);
                });
        }
    }, [randomNumber, dispatch, environment, navigate, accessToken]);

    const handleCancelClick = () => {
        setIsEditing(false);
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };

    console.log('home review:', homeReview)

    const handleSaveClick = () => {
        setIsLoading(true);
        const updatedReviews = homeReview
        const fetchUserData = (index) => {
            if (index >= updatedReviews.length) {
                APIServices.updateHomeReviews(updatedReviews)
                    .then((res) => {
                        console.log("Updating reviews response:", res);
                        setIsEditing(false);
                        setIsLoading(false);
                        setRandomNumber(Math.random())
                        setReviewUpdateAlert(true)

                    })
                    .catch((err) => {
                        console.error("Error in updating reviews:", err);
                        setIsLoading(false);
                        setErrAlert(true)
                    });
                return;
            }

            const review = updatedReviews[index];
            if (!review._id) {
                console.error("Missing _id for review:", review);
                index++;
                fetchUserData(index);
                return;
            }

            if (review?.user_id?.profile_id !== homepageReviews[index]?.user_id?.profile_id) {
                setIsLoading(true)
                APIServices.getUserByID(review?.user_id?.profile_id, adminUserId)
                    .then((res) => {
                        updatedReviews[index] = {
                            ...review,
                            user_id: {
                                _id: res?.data?.user?._id,
                                firstName: res?.data?.user?.firstName,
                                lastName: res?.data?.user?.lastName,
                                city: res?.data?.user?.city,
                                country: res?.data?.user?.country,
                                user_type: res?.data?.user?.user_type,
                                profile_id: review.user_id?.profile_id,
                            }
                        };
                        index++;
                        fetchUserData(index);
                        setIsLoading(false)
                    })
                    .catch((err) => {
                        if (err.response.status === 404 || err.response.status === 403) {
                            setErrAlert(true)
                            setReviewUpdateAlert(false)
                            setIsLoading(false)
                            alert(`Id ${review?.user_id?.profile_id} do not exist , try with another`)
                        }
                        console.error("Error in getting user:", err);
                        index++;
                        fetchUserData(index);
                    });
            } else {
                index++;
                fetchUserData(index);
            }
        };
        fetchUserData(0);
    };

    const handleChange = (e, index) => {
        const { name, value } = e.target;
        setHomeReview(prevReviews => {
            const updatedReviews = [...prevReviews];
            if (name === 'profile_id' || name === 'city' || name === 'fullName') {
                updatedReviews[index] = {
                    ...updatedReviews[index],
                    user_id: {
                        ...updatedReviews[index]?.user_id,
                        [name]: value
                    }
                };
            } else {
                updatedReviews[index] = {
                    ...updatedReviews[index],
                    [name]: value
                };
            }
            return updatedReviews;
        });
    };

    return (
        <div>
            <Backdrop
                sx={{
                    color: "#ffffff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <AlertComponent
                open={reviewUpdateAlert}
                severity="success"
                onClose={() => setReviewUpdateAlert(false)}
                text="Reviews updated successfully."
            />

            <AlertComponent
                open={errAlert}
                severity="error"
                onClose={() => setErrAlert(false)}
                text="Something went wrong.Please try again after sometime."
            />

            {homeReview.map((eachReview, index) => (
                <div key={index}>
                    <div className='full-label-container'>
                        <div className='label-container'>
                            <p className='label-heading'>City Name</p>
                            {isEditing ? (
                                <input disabled
                                    className='Input-field'
                                    name="city"
                                    value={`${eachReview?.user_id?.city} , ${eachReview?.user_id?.country}`}
                                    onChange={(e) => handleChange(e, index)}
                                />
                            ) : (
                                <p className='Input-field'>{eachReview?.user_id?.city} , {eachReview?.user_id?.country}</p>
                            )}
                        </div>

                        <div className='label-container'>
                            <p className='label-heading'>User name</p>
                            {isEditing ? (
                                <input disabled
                                    className='Input-field'
                                    name="fullName"
                                    value={`${eachReview?.user_id?.firstName} ${eachReview?.user_id?.lastName}`}
                                    onChange={(e) => handleChange(e, index)}
                                />
                            ) : (
                                <p className='Input-field'>{eachReview?.user_id?.firstName} {eachReview?.user_id?.lastName}</p>
                            )}
                        </div>
                        <div className='label-container'>
                            <p className='label-heading'>Profile ID</p>
                            {isEditing ? (
                                <input
                                    className='Input-field'
                                    name="profile_id"
                                    value={eachReview.user_id?.profile_id}
                                    onChange={(e) => handleChange(e, index)}
                                />
                            ) : (
                                <p className='Input-field'>{eachReview.user_id?.profile_id}</p>
                            )}
                        </div>
                    </div>
                    {isEditing ? (
                        <textarea
                            className='paragraph'
                            name="home_review"
                            value={eachReview?.home_review}
                            onChange={(e) => handleChange(e, index)}
                        />
                    ) : (
                        <p className='paragraph-review'>{eachReview?.home_review}</p>
                    )}
                    <br />
                </div>
            ))}

            <div className='edit-button'>
                {isEditing ? (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '18px', marginTop: '30px' }}>
                        <ButtonCompo btnOutlined btnText="Cancel"
                            onClick={handleCancelClick}
                        />
                        <ButtonCompo btnText="Save"
                            onClick={handleSaveClick}
                        />
                    </div>
                ) : (
                    <ButtonCompo btnOutlined btnText="Edit"
                        onClick={handleEditClick}
                    />
                )}
            </div>
        </div>
    );
};

export default RenderReviews;




